/* MURASH: お一人様上限 (product metafield mrg.max_per_order) — 2026-09-10 */
(function () {
  var cartCounts = {};
  function msg(max) { return 'この商品はお一人様 ' + max + ' 点まで（1回のご注文につき）です。'; }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var m = {}; (c.items || []).forEach(function (i) { m[i.product_id] = (m[i.product_id] || 0) + i.quantity; });
      cartCounts = m; return m;
    }).catch(function () { return cartCounts; });
  }
  /* ---- 商品ページ ---- */
  function initProduct() {
    var qty = document.querySelector('input.quantity__input[data-mrg-max]');
    if (!qty || !qty.dataset.mrgMax) return;
    var max = parseInt(qty.dataset.mrgMax, 10), pid = qty.dataset.mrgProductId;
    if (!(max > 0)) return;
    var msgEl = document.querySelector('[data-mrg-limit-msg]');
    var btn = document.querySelector('.product-form__submit');
    var label = btn ? btn.querySelector('span') : null;
    var originalLabel = label ? label.textContent : '';
    var limitLabel = 'お一人様 ' + max + ' 点までです';
    function have() { return cartCounts[pid] || 0; }
    function want() { return parseInt(qty.value, 10) || 1; }
    function remaining() { return Math.max(0, max - have()); }
    function updateButton() {
      qty.removeAttribute('max'); qty.removeAttribute('data-max'); /* + ボタンで上限超えまで上げられるようにし、超えた時点でボタン無効 + 警告 */
      var over = want() + have() > max;
      if (btn && !btn.hasAttribute('data-mrg-unavailable')) {
        btn.disabled = over;
        if (label) label.textContent = over ? limitLabel : originalLabel;
      }
      if (msgEl) {
        if (over) {
          msgEl.hidden = false;
          msgEl.textContent = have() ? ('すでにカートに ' + have() + ' 点入っています。' + msg(max)) : msg(max);
        } else { msgEl.hidden = true; }
      }
    }
    if (btn && btn.disabled) btn.setAttribute('data-mrg-unavailable', '1'); /* 売り切れ・COMING SOON はそのまま */
    refreshCart().then(updateButton);
    ['input', 'change'].forEach(function (ev) { qty.addEventListener(ev, updateButton); });
    document.querySelectorAll('.quantity__button').forEach(function (b) { b.addEventListener('click', function () { setTimeout(updateButton, 0); }); });
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (want() + have() > max) { e.preventDefault(); e.stopImmediatePropagation(); updateButton(); return; }
        setTimeout(function () { refreshCart().then(function () { qty.value = 1; updateButton(); }); }, 1500);
      }, true);
    });
  }
  /* ---- カートページ / ドロワー ---- */
  /* 数量は /cart.js を正として判定 (DOM の data-mrg-qty はドロワー側が古くなることがある) */
  function validateCart() {
    refreshCart().then(function (counts) {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-item[data-mrg-max]')).filter(function (r) { return r.dataset.mrgMax; });
      var overProducts = {};
      rows.forEach(function (r) {
        var p = r.dataset.mrgProductId, max = parseInt(r.dataset.mrgMax, 10), qty = counts[p] || 0;
        var bad = max > 0 && qty > max;
        var w = r.querySelector('.mrg-limit-warn');
        if (bad) {
          overProducts[p] = 1;
          if (!w) { w = document.createElement('p'); w.className = 'mrg-limit-warn'; (r.querySelector('.cart-item__details') || r).appendChild(w); }
          w.textContent = 'お一人様 ' + max + ' 点までです（現在 ' + qty + ' 点）。数量を減らしてください。';
        } else if (w) { w.remove(); }
      });
      var over = Object.keys(overProducts).length;
      document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
        if (over) { b.disabled = true; b.setAttribute('data-mrg-blocked', '1'); }
        else if (b.getAttribute('data-mrg-blocked')) { b.disabled = false; b.removeAttribute('data-mrg-blocked'); }
      });
    });
  }
  var t;
  function scheduleValidate() { clearTimeout(t); t = setTimeout(validateCart, 400); }
  function init() {
    initProduct(); validateCart();
    new MutationObserver(scheduleValidate).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
